<template>
  <Spinner v-if="addressStore.isLoading" />
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--mypage">

      <Header />

      <section class="l-content-area">
        <div class="l-content">

          <!-- MYPAGE -->
          <section class="p-bloc p-bloc--mypage">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">

                <section class="p-mypage">

                  <!-- Mypage Menu -->
                  <NavbarMyPage />

                  <!-- Side Menu -->
                  <SideMenu />

                  <!-- Mypage Content -->
                  <div class="p-mypage__content">
                    <div class="mypage-content">

                      <!-- shipping -->
                      <div class="p-mypage__shipping p-mypage__shipping--list mypage-bloc">
                        <div class="mypage-bloc__head">
                          <h2>{{ $t('LABEL_DELIVERY_ADDRESS_SETTINGS') }}</h2>
                          <div class="mypage-bloc__btn">
                            <button class="bloc__act-btn bloc__act-btn--add-shipping" @click="actionRegister()"><span>{{
                                $t('LABEL_CARD_REGISTER') }}</span><img src="@/assets/img/ui_parts/svg/bloc_btn_add.svg"
                                :alt="$t('LABEL_CARD_REGISTER')" /></button>
                          </div>
                        </div>
                        <div class="mypage-bloc__content">

                          <!-- shipping grid -->
                          <div class="shipping__grid">
                            <div class="c-shipping-card" :class="{ 'is-active': JSON.parse(address.default_flag) }"
                              v-for="(address, i) in addressStore.addresses">
                              <div class="c-flip-card">
                                <!-- front -->
                                <div class="c-flip-card__face c-shipping-card__front">
                                  <div class="c-shipping-card__label">
                                    <h3>{{ $t('LABEL_DELIVERY_ADDRESS') }}<span class="num">{{
                                        (i+1).toString().padStart(2, '0') }}</span></h3>
                                  </div>
                                  <div class="c-shipping-card__data">
                                    <dl class="c-shipping__address">
                                      <dt>{{ $t('LABEL_SHIPPING_RECIPIENT') }}</dt>
                                      <dd>
                                        <p class="name">{{ address.delivering_address_last_name }}{{
                                          address.delivering_address_first_name }}</p>
                                        <p class="kana">{{ address.delivering_address_last_name_kana }}{{
                                          address.delivering_address_first_name_kana }}</p>
                                      </dd>
                                      <dd>
                                        <p class="zipcode">{{ address.zip_code }}</p>
                                        <p class="address">{{ PREFECTURES_JA[address.address_1] }}{{ address.address_2
                                          }}{{ address.address_3 }}</p>
                                      </dd>
                                    </dl>
                                    <dl class="c-shipping__telephone">
                                      <dt>{{ $t('LABEL_PHONE_NUMBER') }}</dt>
                                      <dd>
                                        <p class="number">{{ address.tel }}</p>
                                      </dd>
                                    </dl>
                                  </div>
                                </div>
                                <!-- back -->
                                <div class="c-flip-card__face c-shipping-card__back">
                                  <div class="c-shipping-card__setting">
                                    <ul class="c-shipping__action">
                                      <li><button class="shipping__act-btn shipping__act-btn--edit"
                                          @click="actionEdit(address)">{{ $t('LABEL_BUTTON_EDIT') }}</button></li>
                                      <li><button class="shipping__act-btn shipping__act-btn--select"
                                          @click="addressStore.setDefaultAddress(address)">{{
                                          $t('LABEL_SET_DEFAULT_ADDRESS') }}</button></li>
                                      <li><button class="shipping__act-btn shipping__act-btn--delete">{{
                                          $t('LABEL_CREDIT_CARD_DELETE') }}</button></li>
                                      <li><button class="shipping__act-btn shipping__act-btn--back">{{
                                          $t('LABEL_RETURN_BUTTON') }}</button></li>
                                    </ul>
                                    <div class="c-shipping__confirm">
                                      <p>{{ $t('TEXT_CONFIRM_ADDRESS_DELETE') }}</p>
                                      <ul>
                                        <li><button class="shipping__conf-btn shipping__conf-btn--cancel">{{
                                            $t('LABEL_CANCEL') }}</button></li>
                                        <li><button class="shipping__conf-btn shipping__conf-btn--delete"
                                            @click="addressStore.deleteAddress(address.user_address_id)">{{
                                            $t('LABEL_BUTTON_DELETE') }}</button></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- + -->
                            <div class="c-shipping-add">
                              <button class="card__add-btn card__add-btn--shipping" @click="actionRegister()"><span
                                  class="icon"><img src="@/assets/img/ui_parts/svg/card_btn_add.svg" alt="＋" /></span>{{
                                $t('LABEL_ADD_ADDRESS') }}</button>
                            </div>

                          </div><!-- .shipping__grid -->

                        </div>
                      </div>

                      <!-- shipping - add / edit -->
                      <ShippingAddressForm />

                    </div><!-- .mypage-content -->
                  </div>

                </section>

              </div>
            </div>
          </section>


        </div><!-- .l-content -->
      </section><!-- .l-content-area -->

    </div><!-- .l-project-wrap -->

    <Footer />

  </div>
</template>

<script setup>

import NavbarMyPage from "@/components/NavbarMyPage.vue";
import SideMenu from "@/components/SideMenu.vue";
import ShippingAddressForm from "@/views/ShippingAddressForm.vue";
import { onMounted, onUpdated } from "vue";
import { useShippingAddressStore } from "@/stores/ShippingAddressStore";
import Header from "@/components/Header.vue";
import { initializeMain } from "@/assets/js/entries/main";
import Spinner from "@/components/Spinner.vue";
import Footer from "@/components/Footer.vue";
import { PREFECTURES_JA } from "@/data/constants";

const addressStore = useShippingAddressStore();

onMounted(async () => {
    await addressStore.getShippingAddresses();
    $('html, body').animate({ scrollTop: 0 }, 300);
});

function actionEdit(address) {
    addressStore.isAddressEdit = true;
    addressStore.makeEditFormInputs(address);
}

function actionRegister() {
    addressStore.isAddressEdit = false;
    resetAddressForm();
}

onUpdated(() => {
    initializeMain();
})

function resetAddressForm() {
    addressStore.resetAddressForm();
}
</script>